import { render, staticRenderFns } from "./AddWorkshop.vue?vue&type=template&id=4cf05054&scoped=true&"
import script from "./AddWorkshop.vue?vue&type=script&lang=js&"
export * from "./AddWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./AddWorkshop.vue?vue&type=style&index=0&id=4cf05054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf05054",
  null
  
)

export default component.exports